'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _currency = require('./currency');

Object.defineProperty(exports, 'centsToDollars', {
  enumerable: true,
  get: function get() {
    return _currency.centsToDollars;
  }
});
Object.defineProperty(exports, 'dollarsToCents', {
  enumerable: true,
  get: function get() {
    return _currency.dollarsToCents;
  }
});
Object.defineProperty(exports, 'formatCentsToDollars', {
  enumerable: true,
  get: function get() {
    return _currency.formatCentsToDollars;
  }
});
Object.defineProperty(exports, 'formatDollars', {
  enumerable: true,
  get: function get() {
    return _currency.formatDollars;
  }
});
Object.defineProperty(exports, 'formatDollarsPerHour', {
  enumerable: true,
  get: function get() {
    return _currency.formatDollarsPerHour;
  }
});

var _dates = require('./dates');

Object.defineProperty(exports, 'isToday', {
  enumerable: true,
  get: function get() {
    return _dates.isToday;
  }
});
Object.defineProperty(exports, 'isPastDate', {
  enumerable: true,
  get: function get() {
    return _dates.isPastDate;
  }
});
Object.defineProperty(exports, 'isFutureDate', {
  enumerable: true,
  get: function get() {
    return _dates.isFutureDate;
  }
});
Object.defineProperty(exports, 'isInDateRange', {
  enumerable: true,
  get: function get() {
    return _dates.isInDateRange;
  }
});

var _getFirstElement = require('./get-first-element');

Object.defineProperty(exports, 'getFirstElement', {
  enumerable: true,
  get: function get() {
    return _getFirstElement.getFirstElement;
  }
});

var _loadDynamicScript = require('./load-dynamic-script');

Object.defineProperty(exports, 'loadDynamicScript', {
  enumerable: true,
  get: function get() {
    return _loadDynamicScript.loadDynamicScript;
  }
});

var _localStorage = require('./local-storage');

Object.defineProperty(exports, 'localStorageGet', {
  enumerable: true,
  get: function get() {
    return _localStorage.localStorageGet;
  }
});
Object.defineProperty(exports, 'localStorageSet', {
  enumerable: true,
  get: function get() {
    return _localStorage.localStorageSet;
  }
});
Object.defineProperty(exports, 'localStorageClear', {
  enumerable: true,
  get: function get() {
    return _localStorage.localStorageClear;
  }
});
Object.defineProperty(exports, 'localStorageAppend', {
  enumerable: true,
  get: function get() {
    return _localStorage.localStorageAppend;
  }
});

var _pluralize = require('./pluralize');

Object.defineProperty(exports, 'pluralize', {
  enumerable: true,
  get: function get() {
    return _pluralize.pluralize;
  }
});
Object.defineProperty(exports, 'pluralizeWithCount', {
  enumerable: true,
  get: function get() {
    return _pluralize.pluralizeWithCount;
  }
});

var _round = require('./round');

Object.defineProperty(exports, 'roundToXDecimalPlaces', {
  enumerable: true,
  get: function get() {
    return _round.roundToXDecimalPlaces;
  }
});
Object.defineProperty(exports, 'roundToZeroDecimalPlaces', {
  enumerable: true,
  get: function get() {
    return _round.roundToZeroDecimalPlaces;
  }
});
Object.defineProperty(exports, 'roundToTwoDecimalPlaces', {
  enumerable: true,
  get: function get() {
    return _round.roundToTwoDecimalPlaces;
  }
});

var _time = require('./time');

Object.defineProperty(exports, 'formatTime', {
  enumerable: true,
  get: function get() {
    return _time.formatTime;
  }
});
Object.defineProperty(exports, 'formatHours', {
  enumerable: true,
  get: function get() {
    return _time.formatHours;
  }
});
Object.defineProperty(exports, 'formatTimeWithPeriod', {
  enumerable: true,
  get: function get() {
    return _time.formatTimeWithPeriod;
  }
});
Object.defineProperty(exports, 'combinedDateAndTime', {
  enumerable: true,
  get: function get() {
    return _time.combinedDateAndTime;
  }
});
Object.defineProperty(exports, 'minutesToHours', {
  enumerable: true,
  get: function get() {
    return _time.minutesToHours;
  }
});
Object.defineProperty(exports, 'hoursToMinutes', {
  enumerable: true,
  get: function get() {
    return _time.hoursToMinutes;
  }
});
Object.defineProperty(exports, 'formatMinutesToHours', {
  enumerable: true,
  get: function get() {
    return _time.formatMinutesToHours;
  }
});
Object.defineProperty(exports, 'formatHoursToMinutes', {
  enumerable: true,
  get: function get() {
    return _time.formatHoursToMinutes;
  }
});

var _age = require('./users/age');

Object.defineProperty(exports, 'calculateUserAge', {
  enumerable: true,
  get: function get() {
    return _age.calculateUserAge;
  }
});

var _name = require('./users/name');

Object.defineProperty(exports, 'getInitials', {
  enumerable: true,
  get: function get() {
    return _name.getInitials;
  }
});
Object.defineProperty(exports, 'getFullName', {
  enumerable: true,
  get: function get() {
    return _name.getFullName;
  }
});
Object.defineProperty(exports, 'makePossessive', {
  enumerable: true,
  get: function get() {
    return _name.makePossessive;
  }
});

var _removeFirstInstance = require('./remove-first-instance');

Object.defineProperty(exports, 'removeFirstInstance', {
  enumerable: true,
  get: function get() {
    return _removeFirstInstance.removeFirstInstance;
  }
});

var _serializePromises = require('./serialize-promises');

Object.defineProperty(exports, 'serializePromises', {
  enumerable: true,
  get: function get() {
    return _serializePromises.serializePromises;
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/clark-utils/lib/index.js
// module id = 9
// module chunks = 0